import angular from 'angular';
import { PermissionsService } from '../permissions';

interface ButtonGroupActionItem {
  label: string;
  permissions?: string[];
  action: () => void;
}

export interface ButtonGroupAction extends ButtonGroupActionItem {
  items?: ButtonGroupActionItem[];
}

export class ButtonGroupActionsService {
  static $inject = ['PermissionsService'];

  constructor(private permissionsService: PermissionsService) {}

  normalize(action?: ButtonGroupAction): ButtonGroupAction | undefined {
    if (action == null) {
      return undefined;
    }

    if (action.permissions && this.permissionsService.check(action.permissions) === false) {
      return undefined;
    }

    const items = (action.items ?? []).filter((item) => {
      if (item.permissions == null) {
        return true;
      }

      return this.permissionsService.check(item.permissions);
    });

    return { ...action, items };
  }
}

export const ButtonGroupActionsServiceModule = angular
  .module('acme.common.service.button-group-actions', ['acme.common.service.permissions'])
  .service('ButtonGroupActionsService', ButtonGroupActionsService).name;
